import React from 'react';
import { Link } from 'react-router-dom';
import './Sitemap.css';

const siteStructure = [
  {
    category: 'Main Pages',
    links: [
      { path: '/', label: 'Home' },
      { path: '/residential-solutions', label: 'Residential Solar & Battery Solutions' },
      { path: '/commercial-solutions', label: 'Commercial Solar Solutions' },
      { path: '/why-us', label: 'Why Choose Us' },
      { path: '/blog', label: 'Blog' },
      { path: '/contact', label: 'Contact Us' },
      { path: '/enquiry', label: 'Get a Free Quote / Enquiry' },
    ],
  },
  {
    category: 'Products & System Configurations',
    links: [
      { path: '/product', label: 'All Products Overview' },
      { path: '/product/goodwe-esa', label: 'GoodWe ESA Series' },
      { path: '/product/sofar', label: 'Sofar Solar Inverter & Battery Solutions' },
      { path: '/product/alpha-ess', label: 'Alpha ESS Energy Storage Systems' },
      { path: '/product/alpha-ess-smile-g3-s5', label: 'Alpha ESS SMILE-G3-S5' },
      { path: '/product/alpha-ess-smile-g3', label: 'Alpha ESS SMILE-G3' },
    ],
  },
  {
    category: 'Blog & Articles',
    links: [
      { path: '/are-solar-panels-worth-it-in-melbourne', label: 'Are Solar Panels Worth It in Melbourne?' },
      { path: '/how-long-do-solar-batteries-last', label: 'How Long Do Solar Batteries Last?' },
      { path: '/how-long-do-solar-panels-last', label: 'How Long Do Solar Panels Last?' },
      { path: '/how-many-solar-panels-do-i-need', label: 'How Many Solar Panels Do I Need?' },
    ],
  },
];

export default function Sitemap() {
  return (
    <div className="sitemap-page">
      <div className="sitemap-hero">
        <div className="sitemap-container">
          <h1 className="sitemap-title">Sitemap</h1>
          <p className="sitemap-subtitle">
            Explore all pages and product solutions offered by Watt &amp; Wattle.
          </p>
        </div>
      </div>

      <div className="sitemap-container sitemap-content">
        <div className="sitemap-grid">
          {siteStructure.map((group, index) => (
            <div key={index} className="sitemap-card">
              <h2 className="sitemap-card-title">{group.category}</h2>
              <ul className="sitemap-list">
                {group.links.map((link, linkIndex) => (
                  <li key={linkIndex} className="sitemap-item">
                    <Link to={link.path} className="sitemap-link">
                      <span className="sitemap-link-icon">›</span>
                      <span className="sitemap-link-text">{link.label}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
